import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import Accordions from '../Accordions/Accordions';

export default function SlideDownWrapper({
  label,
  placeholder,
  forwardedRef,
  ...props
}) {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef();
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);
  const clickHandler = (e) => {
    if (e.target.tagName.toLowerCase() === 'input') {
      return;
    }

    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  return (
    <Accordions
      isOpen={isOpen}
      onClick={clickHandler}
      sx={{
        '& .MuiAccordionSummary-content': {
          '& .MuiTypography-root': {
            fontSize: '18px !important',
          },
        },
      }}
      summaryProps={{
        fontSize: 14,
        fontFamily: 'Inter',
        lineHeight: '20px',
      }}
      smallIcon
      summary={label}
      details={
        <TextField
          ref={forwardedRef}
          inputRef={inputRef}
          label={placeholder}
          {...props}
        />
      }
    />
  );
}
